import type { FC, ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';
import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';

export const DealAssistantTheme: FC<{ children: ReactNode }> = ({ children }) => {
    const theme = useInterstateTheme();

    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
